import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { EquipmentModelLatestFipeDataTransmission } from '@/features/equipments/types/equipmentModelLatestFipe'

interface FipeTransmissionAccordionProps {
  transmissionData?: EquipmentModelLatestFipeDataTransmission
}

export default function FipeTransmissionAccordion({ transmissionData }: FipeTransmissionAccordionProps) {
  return (
    <Accordion
      name="Transmission"
      head="Transmissão"
      body={
        <div className="flex flex-col gap-1">
          <div className='flex items-center gap-1'>
            <InfoField 
              label="Tração" 
              value={transmissionData?.Tracao} 
            />
            <InfoField 
              label="Câmbio" 
              value={transmissionData?.Cambio} 
            />
            <InfoField 
              label="Acoplamento" 
              value={transmissionData?.Acoplamento} 
            />
          </div>
          <InfoField 
            label="Código Câmbio" 
            value={transmissionData?.["Codigo Cambio"]} 
          />
        </div>
      }
    />
  )
}